<template>
	<div class="hello">
		<div class="header">
			<div @click="backJump" style="color: #fff;padding-top: 10px;margin-left: 10px;">
				<span style="line-height: 30px;"><i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>返回</span>
			</div>
			<div class="clear"></div>
			<img src="../assets/topback.png" style="width: 50%;height: 75%;float: right;margin-top: -10px;" alt="">
			<div>
				<h2><span>新</span>增缴费</h2>
			</div>
		</div>
		<div class="center" style="position: relative;">
				<div class="center-top">
					<div class="top_content content">
						<div class="bt">
							<img src="../assets/dian.png" >
							<span>电费</span>
						</div>
						<div class="heiall" style="margin-top: 40px;" rule="">
							<span style="color: #8e8e8e">识别编码</span><span style="float: right;"><a href="" style="color: #0f72dd;">忘记识别编码？</a></span>
							<van-field v-model="hh" label="" @blur="tips" style="border-bottom: 1px solid #dee1e5;font-size: 16px;height: 50px;line-height: 50px;" />
						</div>
					</div>
				</div>
<!--				<div class="center-bottom">-->
<!--					<div class="bot_content content">-->
<!--						<div >-->
<!--							<p>请输入手机号</p>-->
<!--							<van-field v-model="phone" type="tel" style="border-bottom: 1px solid #dee1e5;font-size: 16px;"/>-->
<!--							<p>验证码</p>-->
<!--							<van-field v-model="number" type="number" :maxlength="6" style="width:30%;float: left;border-bottom: 1px solid #dee1e5;font-size: 16px;" />-->
<!--							<van-button type="default" style="float: right;margin-top:-15px;width: 40%;" v-show="show" @click="getCode">获取验证码</van-button>-->
<!--							<van-button type="default" style="float: right;margin-top:-15px" v-show="!show" class="count">{{count}} s</van-button>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
		</div>
		
		<div class="foot">
			<div class="foot-content">
				<van-checkbox v-model="checked">同意<a href="" style="color: #0F72DD;">《生活缴费协议》</a></van-checkbox>
				<van-button @click="fationJump" :disabled="nextPage" type="info" style="margin-top: 20px;width: 100%;border-radius: 10px;height: 50px;">下一步</van-button>
			</div>
		</div>
<!--    <van-notify v-model:show="meshow" type="success">-->
<!--      <van-icon name="bell" style="margin-right: 4px;" />-->
<!--      <span>通知内容</span>-->
<!--    </van-notify>-->
	</div>
</template>

<script>
  import {getSend, getSms, houseIf} from "../common/api/pay";
  import jump from "../common/jump";
	export default {
	  data() {
	    return {
			hh:'',//户号
			number:'',//验证码
			show: true,//验证码显示
			count: '',//验证码数字倒计时
			timer: null,//请求倒计时
			checked : true,//绑定信息
			address:'',//住址
      nextPage:true,//下一页面
			phone:'',//验证码手机号
      tenantId:'',//住户id
        meshow:false
	    };
	  },
	  mounted(){},
	  methods:{
		  //识别编码的判断
		  tips(){
		    // this.$toast.loading("校验中")
        houseIf({houseHoldNumber:this.hh}).then((res)=>{
          if(res.data.length == '0'){
            // this.meshow = true
            // this.$notify("该识别编码不存在，或识别编码填写错误")
            this.nextPage = true
            return
          }
          else if(res.data[0].devType != 0){
            this.$toast.fail("类型错误哦")
            this.nextPage = true
            return
          }
          else{
            this.nextPage = false
          }
          this.devAddress = res.data[0].actName,
          this.tenantId = res.data[0].tenantId
			  })
			  .catch(function (error) {
			    console.log(error);
			  });
		  },
      //退回上一页面
      backJump(){
        this.$destroy()
        jump.$emit('back')
        this.$router.go(-1)
      },
		  //跳转确认信息页面
		  fationJump(){
			  if(this.hh == ''){
				  this.$toast.fail("请完善信息");
				  return ;
			  }
        // getSms({phone:this.phone,code : this.number}).then((res)=>{
				//   		if(res.data == true){
				  		this.$router.push({
				  				path: "/pay-really",
				  				query:{
									 houseHoldNumber:this.hh,
                   tenantId:this.tenantId,
                   devAddress:this.devAddress
				  				}
				  			})
				  		// }
						// else{
						// 	this.$toast.fail("验证码错误")
						// }
				  // })
		  },
      //发送验证码
		  getCode(){
			  if(this.phone == ''){
				  this.$toast.fail("请输入手机号")
				  return ;
			  }
        getSend({phone:this.phone}).then((res)=>{
				  if(res.data.data == true){
					  const TIME_COUNT = 60;
					  if (!this.timer) {
					    this.count = TIME_COUNT;
					    this.show = false;
					    this.timer = setInterval(() => {
					    if (this.count > 0 && this.count <= TIME_COUNT) {
					      this.count--;
					     } else {
					      this.show = true;
					      clearInterval(this.timer);
					      this.timer = null;
					     }
					    }, 1000)
					   }
				  }
				  else{
				    this.$toast.fail(res.data)
          }
			  })
		  }
	  }
	};
</script>

<style scoped>
	.header{
		width: 100%;
		height: 25vh;
		background-color: #295ad0;
	}
	/deep/.van-cell__title{
		    margin: 10px 15px;
	
	}
	.header h2{
		letter-spacing:2px;
		color: rgb(255, 255, 255);
		line-height: 50px;
		position: relative;
		margin-left:20px
	}
	.header h2 span{
		border-bottom: 3px solid #fff;
	}
	.bt{
		margin-top:20px
	}
	.bt img{
		width: 38px;
		height:38px;
		float: left;
	}
	p{
		color: #8e8e8e;
	}
	.bt span{
		line-height: 42px;
		margin-left: 10px;
		font-size: 20px;
	}
	.heiall{
		height:80px;
		margin-top: 5px;
		/* line-height: 50px; */
	}
	.center{
		width:90%;
		height:370px;
		margin: 0 auto;
		border-radius: 10px;
		margin-top: -15px;
		background-color: #fff;
	}
	.center-top{
		width: 100%;
		height:250px;
		background-color: #fff;
		border:1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 1px 1px;
		border-radius: 10px;
	}
	.center-bottom{
		width: 100%;
		height:200px;
		border:1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 1px 1px;
		background-color: #fff;
		border-radius: 10px;
		margin-top: 50px;
	}
	.content {
		width: 80%;
		margin: 0 auto;
	}
	.bot_content{
		margin-top: 28px;
	}
	.foot{
		height: 130px;
		border-top:1px solid #dee1e5 ;
		box-shadow: #dee1e5 0px 0px 1px 1px;
		border-radius: 10px;
	}
	.foot-content{
		width: 90%;
		margin: 0 auto;
		margin-top:20px;
		height: 110px;
		
	}
</style>
